import * as React from "react";
import styles from "./ExportActiveClients.module.scss";
import { Button } from "../../../bits/Button/Button";
import { fxs } from "../../../../../utils/firestore";
import { httpsCallable } from "firebase/functions";
import { useToasts } from "react-toast-notifications";
import { cn } from "../../../../helpers";
import Alert from "../../../bits/Alert/Alert";

export default function ExportActiveClients() {
    const { addToast } = useToasts();
    const [isExporting, setIsExporting] = React.useState(false);
    const [progress, setProgress] = React.useState(5);
    const [exportStatus, setExportStatus] = React.useState<
        "idle" | "success" | "error"
    >("idle");
    const [displayMessage, setDisplayMessage] = React.useState("");

    return (
        <div className={styles.container}>
            <p className={styles.title}>Export active clients</p>
            <p className={styles.description}>
                Click on the button below to export all active clients to{" "}
                <a
                    href="https://docs.google.com/spreadsheets/d/1TNBO2KR8LJEE60p7n2qrNm62VspB-_At3W8EOqk7ew0"
                    target="_blank"
                    rel="noreferrer"
                >
                    the Intake System - Active client list Sheet
                </a>
                . Imports will be added to a sheet titled with the day and time of
                the import.
            </p>

            <div
                className={cn(styles.progressBar, {
                    [styles.error]: exportStatus === "error",
                })}
            >
                <div
                    className={cn(styles.progressFill, {
                        [styles.error]: exportStatus === "error",
                    })}
                    style={{
                        width: `${progress}%`,
                    }}
                />
            </div>

            {exportStatus === "success" && (
                <Alert type="info">Export completed. ({displayMessage})</Alert>
            )}

            <div className={styles.buttonContainer}>
                <Button
                    onClick={async () => {
                        setIsExporting(true);
                        setProgress(0);
                        setExportStatus("idle");

                        const progressInterval = setInterval(() => {
                            setProgress((prev) => {
                                if (prev >= 90) {
                                    clearInterval(progressInterval);
                                    return 90;
                                }
                                return prev + 10;
                            });
                        }, 500);

                        const exportActiveClientFunction = httpsCallable(
                            fxs,
                            "httpFunctionExportActiveClients"
                        );

                        try {
                            const result = await exportActiveClientFunction();
                            const { sheet_title, total_imported } =
                                result.data as any;
                            const summary = `Sheet title: ${sheet_title}, Total exported: ${total_imported}`;
                            setProgress(100);
                            clearInterval(progressInterval);
                            setExportStatus("success");
                            setDisplayMessage(`Export completed.(${summary})`);
                        } catch (ex) {
                            clearInterval(progressInterval);
                            setExportStatus("error");

                            addToast(
                                "Failed to export clients, please contact your administrator.",
                                {
                                    appearance: "error",
                                }
                            );
                        } finally {
                            setIsExporting(false);
                        }
                    }}
                    disabled={isExporting}
                >
                    {isExporting && "Exporting..."}
                    {!isExporting && exportStatus === "success" && "Export Complete"}
                    {!isExporting && exportStatus !== "success" && "Run export"}
                </Button>
            </div>
        </div>
    );
}
